import Vue from 'vue';
import App from './App.vue';
import VueHead from"vue-head";
import VueResource from"vue-resource";
import VuePaginate from"vue-paginate";
import VModal from"vue-js-modal";
import router from './router';
import AnimateCss from 'animate.css';
import Slick from 'vue-slick';
import VueParallaxJs from 'vue-parallax-js'
import VueScrollTo from 'vue-scrollto'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueAnalytics from 'vue-analytics'; 
import VueSimpleAlert from "vue-simple-alert";
import money from 'v-money'
import validate from './const/validate'


Vue.use(VueResource),
Vue.use(VueHead,{separator:"|",complement:"Ponto Fácil"}),
Vue.use(VuePaginate),
Vue.use(VModal, 
  { dynamic: true, dynamicDefaults: { clickToClose: false } }  
),
Vue.use(AnimateCss),
Vue.use(Slick),
Vue.use(Vuetify),
Vue.use(VueParallaxJs),
Vue.use(money, {precision: 4}),
Vue.use(VueSimpleAlert),
Vue.use(VueScrollTo,{
  container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

Vue.config.productionTip = false


// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-159437526-1',
  router
});

Vue.prototype.showModal = function(themodal) {
  this.$modal.show(themodal)
}
Vue.prototype.hideModal = function(themodal) {
  this.$modal.hide(themodal);
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

